import { useCallback, useState } from 'react';
import Toolbar from 'src/components/Toolbar';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Button, { ButtonTypes } from 'src/components/Button';
import TextContentItem from 'src/components/TextContentItem';
import Checkbox from 'src/components/Checkbox';
import './style.scoped.css';
import forwardIcon from 'src/assets/forward_white.svg';
import cancerStore, { CancerStore } from 'src/stores/CancerStore';
import { observer } from 'mobx-react-lite';
import { confirmQuitFlow, sendOpenNewWebview } from 'src/utils';
import PopupService from 'src/utils/PopupService';
import { gaTrackEvent } from '../../api';
import { BUYING_PROCESS, BUYING_PROCESS_STEP, BUYING_PROCESS_TRACKING } from '../../constants';
import UserInfoService from '../../utils/UserInfoService';

interface CommitmentObserverProps {
  cancerStore?: CancerStore;
}

const CommitmentObserver = observer(
  ({ cancerStore }: CommitmentObserverProps) => {
    const { t } = useTranslation();
    const history = useHistory();
    const [isAgreeJoin, setIsAgreeJoin] = useState(
      cancerStore.formInfo?.isAgreeJoin || false
    );
    const [isAgreeTerm, setIsAgreeTerm] = useState(
      cancerStore.formInfo?.isAgreeTerm || false
    );

    const _handleAgreeJoin = useCallback(() => {
      setIsAgreeJoin(!isAgreeJoin);
    }, [setIsAgreeJoin, isAgreeJoin]);

    const _handleAgreeTerm = useCallback(() => {
      setIsAgreeTerm(!isAgreeTerm);
    }, [setIsAgreeTerm, isAgreeTerm]);

    const _handleContinue = useCallback(() => {
      if (!isAgreeJoin || !isAgreeTerm) {
        PopupService.instance.current.open({
          visible: true,
          title: t('notification'),
          content: t('please_read_term_and_condition'),
          okTitle: t('close'),
          onOk: () => {
            PopupService.instance.current.close();
          },
          showIcon: false,
        });
        return;
      }
      cancerStore.updateFormInfo({
        isAgreeJoin,
        isAgreeTerm,
      });

      gaTrackEvent(BUYING_PROCESS_TRACKING,
        BUYING_PROCESS[BUYING_PROCESS_STEP.CommitTermOfUse].name,
        UserInfoService.getUserInfo()?.idCardNo ?? "");

      history.push('/buy-insurance/cancer/confirm-payment');
    }, [history, t, isAgreeJoin, isAgreeTerm, cancerStore]);

    const _handleClose = () => {
      confirmQuitFlow(history);
    };

    const _handleBack = () => {
      history.goBack();
      cancerStore.updateFormInfo({ isAgreeJoin: null, isAgreeTerm: null });
    };

    const _handleViewTerm = (e) => {
      console.log('View Term');
      e.stopPropagation();
      // sendOpenPdf({
      //   name: t('term_and_condition'),
      //   link:
      //     'https://www.mbageas.life/uploads/zmEVVnWZmRgJpAqLIqz6V/BaohiembenhungthuTnC.pdf',
      // });
      // sendOpenNewWebview({
      //   name: t('term_and_condition'),
      //   link:
      //     'https://docs.google.com/gview?embedded=true&url=https://www.mbageas.life/uploads/zmEVVnWZmRgJpAqLIqz6V/BaohiembenhungthuTnC.pdf',
      // });
      history.push('/buy-insurance/cancer/term-and-condition');
    };

    return (
      <div className="screen-container bg-background">
        <Toolbar
          title={t('commitment')}
          type="normal"
          showClose={true}
          onClose={_handleClose}
          onBack={_handleBack}
        />
        <div className="max-w-md mx-auto screenScrollContainer p-4">
          <div className="cardItem">
            <div className="textTitleContainer">{t('commitment_hint')}</div>
            {cancerStore.commitments.map((item, index) => {
              const itemClassName =
                index == 0
                  ? 'textContentItemContainerFirst'
                  : index == cancerStore.commitments.length - 1
                  ? 'textContentItemContainerLast'
                  : 'textContentItemContainer';
              return (
                <div className={itemClassName} key={item.id}>
                  <TextContentItem index={item.id} content={item.name} />
                </div>
              );
            })}
          </div>
          {/* <div className="viewTermContainer">
            <img src={documentBlue} className="documentIcon" />
            {t('view_term')}
          </div> */}
          <div className="mb-4">
            <Checkbox
              text={t('im_agree_join_insurance')}
              checked={isAgreeJoin}
              onCheck={_handleAgreeJoin}
              type="card"
            />
          </div>
          <div className="mb-4">
            <Checkbox
              textComponent={
                <div>
                  <span onClick={_handleAgreeTerm}>
                    {t('i_read_and_agree_with')}{' '}
                  </span>
                  <span
                    className="smallTitle2Primary underline"
                    onClick={_handleViewTerm}
                  >
                    {t('term_and_condition')}
                  </span>
                </div>
              }
              checked={isAgreeTerm}
              onCheck={_handleAgreeTerm}
              type="card"
            />
          </div>
        </div>

        <div className="bottomButtonBlock">
          <div className="flex flex-row">
            <Button
              text={t('continue')}
              buttonType={ButtonTypes.primaryFilled}
              extraClassName="w-full"
              onClick={_handleContinue}
              rightIcon={<img src={forwardIcon} className="w-6 h-6 ml-2" />}
            />
          </div>
        </div>
      </div>
    );
  }
);

const Commitment = () => <CommitmentObserver cancerStore={cancerStore} />;
export default Commitment;
